import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Form.scss'

const Form = props => {
	const { handleSubmit } = props
	return (
		<form styleName="form" onSubmit={handleSubmit}>
			{props.children}
		</form>
	)
}

Form.propTypes = {
	children: React.PropTypes.node,
	handleSubmit: React.PropTypes.func
}

export default CSSModules(Form, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Form/Form.js